import React from "react";
import styled from "styled-components"

import TicketsButton from "./button-tickets"
import MoreInfoButton from "./button-moreinfo"

const ButtonsRow = styled.p`
    > * {
        margin-right: 10px;
    }
`

function Buttons(props) {
  const { show, more, tickets } = props;

  return (
        <ButtonsRow className="buttons">
            {more && <MoreInfoButton show={show} />}
            {(tickets && show.tickets) && <TicketsButton show={show} />}
        </ButtonsRow>
  );
}

export default Buttons;